const {
	onClickOrEnter,
	toggleClass,
	compileTemplate,
	isFocusable,
} = require("./ElevHelpers");

//
// JS for modals
//

// modalTypeOrEl can be a string (modal type) or DOM element with a
// data-modal-type attribute. Modal types are loaded from copy.modals in YAML.
function getVarsFromModalData(modalTypeOrEl) {
	// Check for modal data
	const modalType =
		typeof modalTypeOrEl === "string"
			? modalTypeOrEl
			: modalTypeOrEl.getAttribute("data-modal-type");
	const modalData = window.elevModalData || {};
	const handlebarsVars = modalData[modalType];
	return handlebarsVars;
}

// Null if no modal open. An object with a closeModal method if there is one.
let currModalInfo = null;

function closeCurrentModal() {
	if (currModalInfo) {
		currModalInfo.closeModal();
		currModalInfo = null;
	}
}

function openModalByName(name, focusOnCloseEl, setupFunc) {
	const handlebarsVars = getVarsFromModalData(name);
	openModal(handlebarsVars, focusOnCloseEl, setupFunc);
}

function openModal(handlebarsVars, focusOnCloseEl, setupFunc) {
	closeCurrentModal();

	// Disable scrolling on background
	toggleClass(document.body, "ba11-modal-open", true);

	// Create modal contents
	const modalDiv = document.createElement("div");
	modalDiv.setAttribute("class", "ba11-modal");
	// TODO: if using this to generate a modal with a decision required, change role to alertdialog
	modalDiv.setAttribute("role", "alert");
	modalDiv.setAttribute("aria-modal", true);
	modalDiv.setAttribute("aria-labelled-by", "modal-title");
	modalDiv.setAttribute("aria-described-by", "modal-contents");
	const modalTemplate = compileTemplate("#modalTemplate");
	modalDiv.innerHTML = modalTemplate(handlebarsVars);
	const modalsContainer = document.querySelector("#modalsContainer");
	modalsContainer.appendChild(modalDiv);
	const container = modalDiv.querySelector(".ba11-modal-container");

	// Run setup function
	if (setupFunc) setupFunc(modalDiv);

	// Trap focus
	const preDiv = document.createElement("div");
	const preNode = container.parentNode.insertBefore(
		preDiv,
		container.parentNode.childNodes[0]
	);
	preNode.tabIndex = 0;
	const postDiv = document.createElement("div");
	const postNode = container.parentNode.appendChild(postDiv);
	postNode.tabIndex = 0;

	let ignoreFocusChange = false;
	let lastFocusedEl = null;

	const attemptFocus = function(element) {
		if (!isFocusable(element)) return false;

		ignoreFocusChange = true;
		try {
			element.focus();
		} catch (e) {
			// No-op
		}
		ignoreFocusChange = false;
		return document.activeElement === element;
	};

	const focusFirstDescendant = function(element) {
		for (let i = 0; i < element.childNodes.length; i++) {
			const child = element.childNodes[i];
			if (attemptFocus(child) || focusFirstDescendant(child)) return true;
		}
		return false;
	};

	const focusLastDescendant = function(element) {
		for (let i = element.childNodes.length - 1; i >= 0; i--) {
			const child = element.childNodes[i];
			if (attemptFocus(child) || focusLastDescendant(child)) return true;
		}
		return false;
	};

	const trapFocus = function(event) {
		// Ignore focus events from programmatic focus checks
		if (ignoreFocusChange) {
			return;
		}
		if (container.contains(event.target)) {
			// If it's within the dialog, just set last focused element
			lastFocusedEl = event.target;
		} else {
			// If it isn't you hit a bumper and we direct you to the
			// first or last focusable element in the dialog based on
			// what was last focused
			focusFirstDescendant(container);
			if (lastFocusedEl === document.activeElement) {
				// Unless the last thing you were focused on was the first element,
				// In which case we direct you to the last descendant
				focusLastDescendant(container);
			}
			lastFocusedEl = document.activeElement;
		}
	};
	modalDiv.parentNode.addEventListener("focus", trapFocus, true);

	// Set up close functions
	const closeModalFunc = function() {
		modalDiv.remove();
		preNode.remove();
		postNode.remove();
		toggleClass(document.body, "ba11-modal-open", false);
		if (focusOnCloseEl) focusOnCloseEl.focus();
	};
	const closeButton = modalDiv.querySelector(".ba11-modal-close-button");
	onClickOrEnter(closeButton, closeModalFunc);
	const backdrop = modalDiv.querySelector(".ba11-modal-backdrop");
	backdrop.addEventListener("click", closeModalFunc);
	modalDiv.addEventListener("keydown", evt => {
		if (evt.key === "Escape" || evt.code === "Escape" || evt.which === 27) {
			closeModalFunc();
		}
	});

	focusFirstDescendant(modalDiv);

	currModalInfo = {
		closeModal: closeModalFunc,
	};

	return modalDiv;
}

function setupModalButton(el, setupFunc) {
	const openModalByButton = function() {
		const handlebarsVars = getVarsFromModalData(el);
		return openModal(handlebarsVars, el, setupFunc);
	};

	onClickOrEnter(el, openModalByButton);
}

module.exports = {
	openModal,
	closeCurrentModal,
	setupModalButton,
	openModalByName,
};
